"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContrastButtonLink = exports.ContrastButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const styled_components_1 = require("./styled-components");
exports.ContrastButton = (0, styled_1.default)(styled_components_1.StyledButtonContrast) ``;
exports.ContrastButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.ContrastButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=contrast.js.map